import gql from "graphql-tag";

export default gql`
  query getCertificates($type: CertificateType) {
    getCertificates(type: $type) {
      items {
        userId
        serial
        id
        rfc
        endDate
        type
        createdAt
        cerFile {
          key
          bucket
          region
        }
        keyFile {
          key
          bucket
          region
        }
        keyPassword
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/GetCertificates.js